import {connectScript, IScriptConnection} from 'core/decorators/connectScript';
import {ONLINE_CHAT_VENDOR_SCRIPT_ID} from 'modules/online-chat/constants';

export const connectOnlineChat = (url: string): Promise<IScriptConnection> => {
    return connectScript(url, ONLINE_CHAT_VENDOR_SCRIPT_ID);
};
